module.exports = __webpack_public_path__ + "static/media/play-button.969283cb.svg";